var Marionette = require('backbone.marionette');

var Person = require('../../models/person-model');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');
var utils = new CommonUtils();


var PersonForm = Marionette.View.extend({
    tagName: 'form',
    template: require('../../templates/persons/person-form.html'),
    model: new Person(),
    modelEvents: {
        change: 'render'
    },

    regions: {
        stateSelect: '#state-select'
    },

    ui: {
        email: '#email',
        login: '#login',
        password: '#password',
        passwordHidden: '#password-hidden',
        firstName: '#first-name',
        lastName: '#last-name',
        middleName: '#middle-name',

        addressField: '.address-field',
        zip: '#zip',
        address: '#address',
        town: '#town',

        npi: '#id-npi',
        isPatient: '#is-patient',
        isMd: '#is-md',
        isOfficeAdmin: '#is-office-admin',
        isMedicalDirector: '#is-medical-director',
        isManager: '#is-manager',
        isAdmin: '#is-admin',
        ssn: '#ssn',
        insuranceId: '#insuranceId',
        birthDate: '#birth-date',
        gender: '#gender-values',
        pendingDocsNotifChb: '#pending-docs-notif',
        reviewPeriodDays: '#review-period-days',
        reviewPeriodHours: '#review-period-hours',

        progress: '#progress',
        reRequest: '#re-request',
        fillForm: '#fill-form',

        generatePass: '#generate-pass'
    },

    events: {
        'change @ui.email': 'validate',
        'blur @ui.email': 'validate',

        'blur @ui.login': 'validate',
        'blur @ui.password': 'validate',
        'blur @ui.firstName': 'validate',
        'blur @ui.lastName': 'validate',
        'blur @ui.ssn': 'validate',

        'keyup @ui.login': 'validate',
        'keyup @ui.password': 'validate',
        'change @ui.password': 'validate',
        'keyup @ui.firstName': 'validate',
        'keyup @ui.lastName': 'validate',
        'keyup @ui.ssn': 'validate',

        'keyup @ui.addressField': 'onAddressChange',
        'change @ui.addressField': 'onAddressChange',

        'keyup @ui.npi': 'onNpiKeyup',
        'change @ui.npi': 'onNpiChange',
        'keypress @ui.npi': 'onKeyPress',

        'click @ui.reRequest': 'onReRequest',
        'click @ui.fillForm': 'onFormFill',

        'change @ui.isPatient': 'onChangeIsPatient',
        'change @ui.isMd': 'onChangeIsMd',
        'change @ui.isOfficeAdmin': 'onChangeIsOfficeAdmin',
        'change @ui.isMedicalDirector': 'onChangeIsMedicalDirector',
        'change @ui.isManager': 'onChangeIsManager',
        'change @ui.isAdmin': 'onChangeIsAdmin',
        'change @ui.pendingDocsNotifChb': 'onChangePendingDocsNotif',

        'click @ui.generatePass': 'generatePass'
    },

    tempNpi: '',
    npiPersonData: undefined,

    generatePassButtonText: 'Generate and copy to clipboard',

    templateContext: function () {
        var that = this;
        var bd = that.model.get('object').birthData;
        return {
            isEditMode: that.isEditMode,
            birthData: (bd == '' || bd == null || bd == 0 ? '' : utils.longToDateTimeFormattedInUtc(Number(bd), 'MM/DD/YYYY')),
            generatePassButtonText: that.generatePassButtonText,
            byAdmin: that.getOption('byAdmin'),
            forSignup: that.getOption("forSignup"),
            email: (that.model.get('object').contacts || []).filter(function (contact) {
                return contact.type == 'EMAIL' && contact.preferred == true;
            }).map(function (contact) {
                return contact.data;
            })[0] || '',
            days: utils.getDaysValues(),
            hours: utils.getHoursValues()
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'fillModel', 'clearModel', 'validate', 'validateBy', 'updateValidatingResults', 'onNpiChange',
            'initValidatingResults', 'onKeyPress', 'npiRequest', 'onNpiRequestStart', 'onNpiRequestSuccess', 'onNpiRequestFailure',
            'onNpiRequestEnd', 'onReRequest', 'onFormFill', 'onChangeIsPatient', 'onChangeIsMd', 'onChangePendingDocsNotif', 'generatePass',
            'destroyFilledAddressesAndContacts', 'fillAddressesAndContactsFromNpi', 'onChangeIsAdmin', 'onChangeIsOfficeAdmin',
            'onChangeIsMedicalDirector', 'onChangeIsManager');
        this.model.on('change', this.render, this);
        this.initValidatingResults();
        var object = this.model.get('object');
        if (object.login)
            this.validatingResults.login = true;
        if (object.password || options.isEditMode)
            this.validatingResults.password = true;
        if (object.firstName)
            this.validatingResults["first-name"] = true;
        if (object.lastName)
            this.validatingResults["last-name"] = true;

        this.validatingResults["ssn"] = true;
        this.isEditMode = options.isEditMode;
        this.forSignup = options.forSignup;

        if (!this.forSignup) {
            this.validatingResults["email"] = true;
        }

        if (this.model.get('object').npi && utils.isValidNPI(this.model.get('object').npi) || _.isEmpty(this.model.get('object').npi))
            this.validatingResults["npi"] = true;

        this.addressesAndContactsFromNpi = {};
        this.isAddressFieldFilledManually = true;

        this.address = {
            uuid: utils.generatedUUID(),
            country: '',
            state: '',
            zip: '',
            town: '',
            address: '',
            usage: 'WP',
            source: 'MANUAL'
        };
    },

    initValidatingResults: function () {
        this.validatingResults = _.clone(this.defaultValidatingResults);
    },

    onRender: function () {
        this.ui.birthDate.datepicker({
            format: 'mm/dd/yyyy'
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
        });

        var genderSelectize = this.ui.gender.selectize({
            allowEmptyOption: false,
            inputClass: 'form-control selectize-input normal-width form-control',
            highlight: true,
            openOnFocus: true
        });
        this.genderSelectized = genderSelectize[0].selectize;

        this.ui.reviewPeriodDays.selectize({
            allowEmptyOption: false,
            placeholder: 'Days',
            inputClass: 'form-control selectize-input'
        });

        this.ui.reviewPeriodHours.selectize({
            allowEmptyOption: false,
            placeholder: 'Hours',
            inputClass: 'form-control selectize-input'
        });

        this.ui.ssn.mask("999-99-9999", {
            autoclear: false
        });

        this.ui.progress.parent().hide();
        this.ui.reRequest.parent().hide();

        if (utils.isValidNPI(this.ui.npi.val())) {
            this.npiRequest(this.ui.npi.val());
        } else {
            this.ui.fillForm.prop('disabled', true);
        }

        if (!this.isEditMode)
            this.showStateSelect();
    },

    showStateSelect: function () {
        var that = this;

        that.showChildView('stateSelect', new RemoteSuggesterView({
            tag: 'state',
            inputId: 'state',
            maxNumberOfElements: 20,
            url: '/api/reference/states/~~~',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getValueFn: function (element) {
                return element;
            },
            classes: ["form-control", "address-field"],
            placeholder: "Select state",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return arr[index] || null;
            }
        }));
    },

    onChangeIsPatient: function (event) {
        this.model.get('object').isPatient = event.target.checked;
    },

    onChangeIsMd: function (event) {
        this.model.get('object').isMd = event.target.checked;
    },

    onChangeIsOfficeAdmin: function (event) {
        this.model.get('object').isOfficeAdministrator = event.target.checked;
    },

    onChangeIsMedicalDirector: function (event) {
        this.model.get('object').isMedicalDirector = event.target.checked;
    },

    onChangeIsManager: function (event) {
        this.model.get('object').isManager = event.target.checked;
    },

    onChangeIsAdmin: function (event) {
        this.model.get('object').isAdmin = event.target.checked;
    },

    onChangePendingDocsNotif: function (event) {
        this.model.get('object').pendingDocumentsNotification = event.target.checked;
    },

    onNpiKeyup: function (event) {
        this.onNpi(event);
    },

    onNpiChange: function (event) {
        this.onNpi(event, true);
    },

    onNpi: function (event, copyToLogin) {
        var that = this;
        var value = event.target.value;
        var tempIdOld = that.tempNpi;
        that.tempNpi = value;

        if (!this.isEditMode) {
            var loginVal = that.ui.login.val();
            if (loginVal == '' || loginVal.toLowerCase() == value.toLowerCase().substr(0, value.length - 1)
                || (event.keyCode == 8 && loginVal.toLowerCase().substr(0, loginVal.length - 1) == value.toLowerCase())) {
                that.ui.login.val(value);
                that.ui.login.blur();
            }

            if (copyToLogin && value.length == 10) {
                that.ui.login.val(value);
                that.ui.login.blur();
            }
        }

        if (utils.isValidNPI(value) && tempIdOld != value) {
            this.ui.fillForm.prop('disabled', false);
            window.setTimeout(function () {
                that.npiRequest(value);
            }, 0);
            return;
        } else {
            that.destroyFilledAddressesAndContacts();
        }

        if (_.isEmpty(value)) {
            that.ui.npi.tooltip("destroy");
            that.ui.npi.parent().removeClass('has-error has-feedback');
            that.validatingResults["npi"] = true;
            this.checkSaveBtn();
            this.ui.fillForm.prop('disabled', true);
            return;
        }

        if (!utils.isValidNPI(value)) {
            that.ui.npi.tooltip({title: 'Invalid NPI'});
            this.ui.npi.parent().addClass('has-error has-feedback');
            that.validatingResults["npi"] = false;
            this.checkSaveBtn();
            this.ui.fillForm.prop('disabled', true);
            return;
        }
    },

    npiRequest: function (value) {
        var that = this;
        that.onNpiRequestStart();
        $.ajax({
            type: "GET",
            url: '/api/npi?type=NPI_1&number=' + value,
            statusCode: {
                200: function (response) {
                    if (response.length == 0) {
                        that.onNpiRequestFailure();
                        that.npiPersonData = undefined;
                    }
                    else {
                        that.onNpiRequestSuccess();
                        that.npiPersonData = utils.personDataFromNpiData(response[0]);
                        that.npiData = response[0];
                    }
                }
            },
            error: function (e) {
                that.onNpiRequestEnd();
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },

    onReRequest: function () {
        this.npiRequest(this.ui.npi.val());
    },

    onKeyPress: function (event) {
        event = event || window.event;  // IE support
        var ctrlDown = event.ctrlKey || event.metaKey;

        return event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 37 || event.keyCode == 39 ||
            ctrlDown || event.charCode >= 48 && event.charCode <= 57 && event.target.value.length < 10;
    },

    onNpiRequestStart: function () {
        this.ui.progress.parent().show();
        this.ui.reRequest.parent().hide();
        this.ui.fillForm.parent().hide();
        this.ui.fillForm.prop('disabled', true);
        this.ui.npi.tooltip("destroy");
        this.ui.npi.attr('disabled', true);
    },

    onNpiRequestSuccess: function () {
        this.ui.progress.parent().hide();
        this.ui.reRequest.parent().hide();
        this.ui.fillForm.parent().show();
        this.ui.fillForm.prop('disabled', false);
        this.ui.npi.tooltip({title: 'Person with this NPI found'});
        this.ui.npi.parent().removeClass('has-error has-feedback');
        this.ui.npi.removeAttr('disabled');
        this.validatingResults["npi"] = true;
        this.checkSaveBtn();
    },

    onNpiRequestFailure: function () {
        this.ui.progress.parent().hide();
        this.ui.reRequest.parent().show();
        this.ui.fillForm.parent().hide();
        this.ui.fillForm.prop('disabled', true);
        this.ui.npi.tooltip({title: 'Person with this NPI not found'});
        this.ui.npi.parent().addClass('has-error has-feedback');
        this.ui.npi.removeAttr('disabled');
        this.validatingResults["npi"] = false;
        this.checkSaveBtn();
    },

    onNpiRequestEnd: function () {
        this.ui.progress.parent().hide();
        this.ui.reRequest.parent().hide();
        this.ui.fillForm.prop('disabled', true);
        this.ui.npi.tooltip("destroy");
        this.ui.npi.removeAttr('disabled');
        this.validatingResults["npi"] = false;
        this.checkSaveBtn();
    },

    onFormFill: function () {
        this.ui.isMd.prop('checked', true);
        this.model.get('object').isMd = true;

        this.ui.lastName.val(this.npiPersonData["lastName"]);
        this.validateBy(this.ui.lastName);

        this.ui.firstName.val(this.npiPersonData['firstName']);
        this.validateBy(this.ui.firstName);

        this.ui.middleName.val(this.npiPersonData["middleName"]);

        this.genderSelectized.setValue(this.npiPersonData["gender"], true);

        if (!this.isEditMode) {
            var addressObject = this.npiPersonData['address'];
            this.ui.zip.val(addressObject.zip);
            this.ui.address.val(addressObject.address);
            this.ui.town.val(addressObject.town);
            $('#state').val(addressObject.state);
            this.address.zip = addressObject.zip;
            this.address.address = addressObject.address;
            this.address.town = addressObject.town;
            this.address.state = addressObject.state;

            this.isAddressFieldFilledManually = false;
        }

        this.ui.login.val(this.ui.npi.val());

        this.fillAddressesAndContactsFromNpi();
        notificationsChannel.request('show:notification', {
            message: 'Profile is filled with data from NPI registry',
            code: 200
        });
    },

    destroyFilledAddressesAndContacts: function () {
        this.addressesAndContactsFromNpi = {};
    },

    fillAddressesAndContactsFromNpi: function () {
        this.addressesAndContactsFromNpi = utils.addressesAndContactsFromNpiData(this.npiData);
    },

    onAddressChange: function (event) {
        this.address[event.target.id] = event.target.value;
        this.isAddressFieldFilledManually = true;
    },

    fillModel: function () {
        var that = this;
        var object = this.model.get('object');
        var contacts = object.contacts || [];
        var addresses = object.addresses || [];
        var representatives = object.representatives || [];

        if (this.forSignup) {
            contacts.push({
                data: that.ui.email.val(),
                type: 'EMAIL',
                preferred: true,
                source: 'MANUAL'
            });
        }

        if (that.addressesAndContactsFromNpi.addresses && !_.isEmpty(that.addressesAndContactsFromNpi.addresses)) {
            addresses = addresses.filter(function (address) {
                return address.source != 'NPI';
            });
            that.addressesAndContactsFromNpi.addresses.forEach(function (address) {
                addresses.push(address);
            });
        }

        if (that.addressesAndContactsFromNpi.contacts && !_.isEmpty(that.addressesAndContactsFromNpi.contacts)) {
            var preferredContacts = contacts.filter(function (contact) {
                return contact.preferred === true;
            });
            contacts = contacts.filter(function (contact) {
                return contact.source != 'NPI';
            });
            that.addressesAndContactsFromNpi.contacts.forEach(function (contact) {
                if (contact.type === "FAX" && (preferredContacts.length == 0 || preferredContacts.filter(function (ctct) {
                        return ctct.data === contact.data && contact.type === "FAX" && ctct.type === "FAX";
                    }).length > 0)) {
                    contact.preferred = true;
                } else {
                    contact.preferred = false;
                }
                contacts.push(contact);
            });
        }

        if (!that.isEditMode && that.isAddressFieldFilledManually) {
            that.address.source = "MANUAL";
            addresses.push(that.address);
        }

        that.model.set({
            object: utils.mergeObjectsLeft(object, {
                firstName: that.ui.firstName.val(),
                lastName: that.ui.lastName.val(),
                middleName: that.ui.middleName.val(),
                login: that.isEditMode ? that.model.get('object').login : that.ui.login.val(),
                password: that.isEditMode ? "" : that.ui.password.val(),
                address: that.ui.address.val(),
                npi: that.ui.npi.val(),
                ssn: that.ui.ssn.val().replace(new RegExp('-', 'g'), ''),
                insuranceId: that.ui.insuranceId.val(),
                isMd: object.isMd,
                isAdmin: object.isAdmin,
                isPatient: object.isPatient,
                isOfficeAdministrator: object.isOfficeAdministrator,
                isMedicalDirector: object.isMedicalDirector,
                isManager: object.isManager,
                pendingDocumentsNotification: object.pendingDocumentsNotification,
                birthData: utils.dateToLongInUtc(that.ui.birthDate.val()),
                gender: that.ui.gender.val(),
                contacts: contacts,
                addresses: addresses,
                representatives: representatives,
                defaultReviewPeriod: {
                    days: that.ui.reviewPeriodDays.val(),
                    hours: that.ui.reviewPeriodHours.val()
                }
            })
        }/*, {validate: true}*/);

        return this.model;
    },

    clearModel: function () {
        this.model.set(this.model.defaults);
        return this.model;
    },

    defaultValidatingResults: {
        "email": false,
        "login": false,
        "password": false,
        "first-name": false,
        "last-name": false,
        "npi": false
    },

    validatingResults: undefined,

    validatingFunctions: {
        "email": function (value) {
            if (_.isEmpty(value))
                return "Email should be filled";
            if (!utils.isValidEmail(value))
                return "Invalid email";
            else return "";
        },
        "login": function (value) {
            if (value.length < 4)
                return "Login length should be at least 4 characters long";
            else return "";
        },
        "password": function (value) {
            if (value.length < 8 || !(/[\d]/.test(value)) || !(/[a-z]/.test(value)) || !(/[A-Z]/.test(value))) {
                return "Password length should be at least 8 characters long and contains at least 1 letter, 1 digit and 1 capital letter.";
            }
            else
                return "";
        },
        "first-name": function (value) {
            if (value.length == 0)
                return "First name should not be empty";
            else return "";
        },
        "last-name": function (value) {
            if (value.length == 0)
                return "Last name should not be empty";
            else return "";
        },
        "ssn": function (value) {
            value = value.replace('___-__-____', '');

            if (value.indexOf('_') > -1) {
                return "Invalid SSN";
            } else if (_.isEmpty(value))
                return "";
            else
                return "";
        }
    },

    validate: function (event) {
        var jQelement = $(event.target);
        this.validateBy(jQelement);
    },

    validateBy: function (jQelement) {
        var value = jQelement.val();
        var id = jQelement.attr('id');
        var checkResult = this.validatingFunctions[id](value);

        if (this.isEditMode && (id == "password" || id == 'login')) {
            checkResult = "";
        }

        if (checkResult.length > 0) {
            this.addTooltip(jQelement, checkResult);
            this.addErrorClass(jQelement);
            this.updateValidatingResults(id, false);
        }
        else {
            this.removeTooltip(jQelement);
            this.removeErrorClass(jQelement);
            this.updateValidatingResults(id, true);
        }
    },

    updateValidatingResults: function (name, value) {
        this.validatingResults[name] = value;
        this.checkSaveBtn();
    },

    addTooltip: function (jQelement, text) {
        jQelement.tooltip({title: text});
    },

    removeTooltip: function (jQelement) {
        jQelement.tooltip("destroy");
    },

    addErrorClass: function (jQelement) {
        jQelement.parent().parent().addClass('has-error has-feedback');
    },

    removeErrorClass: function (jQelement) {
        jQelement.parent().parent().removeClass('has-error has-feedback');
    },

    checkSaveBtn: function () {
        if (this.validatingResults["email"] && this.validatingResults.login && this.validatingResults.password
            && this.validatingResults["first-name"] && this.validatingResults["last-name"]
            && this.validatingResults["ssn"] && this.validatingResults["npi"]) {
            this.triggerMethod('person:save:valid', {result: true});
        } else {
            this.triggerMethod('person:save:valid', {result: false});
        }
    },

    generatePass: function () {
        var password = utils.generatePassword(8);
        this.ui.password.val(password);
        this.ui.passwordHidden.val(password);
        this.ui.passwordHidden.show();
        this.ui.passwordHidden.select();
        document.execCommand('copy');
        this.ui.passwordHidden.hide();
        this.ui.passwordHidden.val('');

        this.ui.generatePass.toggleClass('btn-primary');
        this.ui.generatePass.toggleClass('btn-success');
        this.ui.generatePass.html('Copied');
        this.ui.generatePass.prop('disabled', function (i, v) {
            return !v;
        });

        var that = this;
        setTimeout(function () {
            that.ui.generatePass.toggleClass('btn-primary');
            that.ui.generatePass.toggleClass('btn-success');
            that.ui.generatePass.html(that.generatePassButtonText);
            that.ui.generatePass.prop('disabled', function (i, v) {
                return !v;
            });
        }, 1000);
        this.validateBy($(that.ui.password));
    },

    validateAllRequiredFields: function () {
        this.validateBy(this.ui.login);
        this.validateBy(this.ui.password);
        this.validateBy(this.ui.firstName);
        this.validateBy(this.ui.lastName);
        this.validateBy(this.ui.ssn);
    }

});

module.exports = PersonForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/person-form-view.js
// module id = 336
// module chunks = 0